(function () {
  var root = document.querySelector('[data-gsg]');
  if (!root) return;

  root.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link || !root.contains(link)) return;

    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    if (!id) return;

    var target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (history.replaceState) {
      history.replaceState(null, '', '#' + id);
    }
  });
})();
